import gql from "graphql-tag"

import Recognition from "../fragments/Recognition"

const mutation = gql`
  mutation CreateRecognition($recognition: RecognitionInput!) {
    createRecognition(recognition: $recognition) {
      ...recognitionFields
    }
  }
  ${Recognition}
`

export default mutation
